PluginRegistry.add('route', [
    {
        'url': '/cluster',
        'module': 'graphdb.framework.clustermanagement',
        'chunk': 'clustermanagement',
        'path': 'clustermanagement/app',
        'controller': 'ClusterManagementCtrl',
        'templateUrl': 'pages/cluster-management/clusterInfo.html',
        'helpInfo': 'view.clusterManagement.helpInfo',
        'title': 'view.clusterManagement.title',
        'documentationUrl': 'creating-a-cluster.html#using-the-workbench'
    }
]);

PluginRegistry.add('main.menu', {
    'items': [{
        label: 'Cluster',
        labelKey: 'menu.cluster.label',
        href: 'cluster',
        order: 20,
        role: 'ROLE_USER',
        parent: 'Setup',
        guideSelector: 'sub-menu-cluster',
        testSelector: 'sub-menu-cluster'
    }]
});

